import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Lock, LogIn } from 'react-feather';
import { useKeycloak } from '@react-keycloak/web';

const LoginPage = () => {
  const navigate = useNavigate();
  const { keycloak, initialized } = useKeycloak();
  
  // Redirect to workspaces if already authenticated, or trigger Keycloak login
  useEffect(() => {
    if (initialized) {
      if (keycloak.authenticated) {
        navigate('/workspaces');
      } else {
        // If not authenticated, immediately trigger Keycloak login
        keycloak.login();
      }
    }
  }, [initialized, keycloak.authenticated, navigate]);
  
  // Show loading spinner while initializing
  return (
    <div className="flex justify-center items-center h-screen bg-gray-50">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mb-4 mx-auto"></div>
        <p className="text-gray-600">Preparing login...</p>
      </div>
    </div>
  );
};

export default LoginPage; 